/* istanbul ignore file */

import { mode } from "@chakra-ui/theme-tools";

const variants = {
  outline: (props) => ({
    field: {
      _placeholder: {
        color: mode("rgba(27, 34, 40, 0.4)", "whiteAlpha.400")(props),
      },
    },
  }),
};

const defaultProps = {
  focusBorderColor: "integrator.500",
};

const input = {
  variants,
  defaultProps,
};

export default input;
